export const RELEASE_TAG_PATTERN = /^(?:OMNETIC-release-)?(\d+)\.(\d+)\.(\d+)(?:-hotfix)?$/;
